module.exports = __webpack_public_path__ + "static/c-programming-language-76d7cc45240222293a381cd9b2e9a43e.jpg";